export const Table = {
    limit: 50,
    page: 1,
    externalSorting: true,
    options: {
        method: 'getTableData',
        selectable: false,
    },
    column: {
        draggable: false,
        flexGrow: 1,
        resizeable: false,
    },
    datefields: {
        minWidth: 200,
    },
};
